module.exports = __webpack_public_path__ + "img/image_gallery6.282c1165.jpg";